// Opzioni dei filtri "Impianto" e "Linea": i nomi si ripetono tra zone (es. L1), quindi si mostrano con la zona.

const conZona = (righe, zone) => {
  const codici = new Map((zone || []).map((g) => [g.id, g.codice]));
  return (righe || [])
    .map((r) => ({
      value: r.id,
      label: `${codici.get(r.zona_id) ?? '?'} · ${r.nome}${r.attivo ? '' : ' (disattivato)'}`,
    }))
    .sort((a, b) => a.label.localeCompare(b.label, 'it', { numeric: true }));
};

export const opzioniFiltroImpianti = conZona;
export const opzioniFiltroLinee = conZona;
